export const ORASE = [
  "Alba Iulia", "Arad", "Bacău", "Baia Mare", "Bistrița", "Botoșani",
  "Brăila", "Brașov", "București", "Buzău", "Cluj-Napoca", "Constanța",
  "Craiova", "Drobeta-Turnu Severin", "Deva", "Focșani",
  "Galați", "Giurgiu", "Iași", "Ilfov", "Miercurea Ciuc", "Oradea",
  "Piatra Neamț", "Pitești", "Ploiești", "Râmnicu Vâlcea", "Reșița",
  "Satu Mare", "Sfântu Gheorghe", "Sibiu", "Slatina", "Slobozia",
  "Suceava", "Târgoviște", "Târgu Jiu", "Târgu Mureș", "Timișoara",
  "Tulcea", "Vaslui", "Zalău", "Alexandria"
];

export const RASE_CAINE = [
  "Metis / Fără rasă", "Labrador", "Golden Retriever", "Ciobănesc German",
  "Bulldog", "Beagle", "Pudel", "Rottweiler", "Yorkshire Terrier",
  "Boxer", "Dachshund", "Husky Siberian", "Doberman", "Chihuahua",
  "Shih Tzu", "Border Collie", "Cocker Spaniel", "Dalmatian",
  "Pitbull", "Malinois", "Ciobănesc Românesc Mioritic",
  "Ciobănesc Românesc Carpatin", "Altă rasă"
];

export const RASE_PISICA = [
  "Metisă / Fără rasă", "Persană", "Maine Coon", "Siameză",
  "British Shorthair", "Ragdoll", "Bengaleză", "Sfinx",
  "Norvegiană de Pădure", "Abisiniană", "Scottish Fold",
  "Rusă Albastră", "Birmaneză", "Somaleză", "Altă rasă"
];

export const CULORI = [
  "Alb",
  "Negru",
  "Gri",
  "Maro",
  "Bej",
  "Crem",
  "Auriu",
  "Galben",
  "Roșcat (Portocaliu)",
  "Negru-Alb",
  "Alb-Maro",
  "Tricolor",
  "Tigrat (dungi)",
  "Pătat",
  "Marmorat",
  "Mixt / Altul"
];